import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const ServiceHubIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    "data-icon-name": "ServiceHub",
    viewBox: "0 0 32 32",
    focusable: "false",
    children: /*#__PURE__*/_jsx("path", {
      d: "m27.772 17.441-8.82 9.035a4.15 4.15 0 0 1-2.956 1.257c-.015 0-.031.005-.052.005a4.17 4.17 0 0 1-2.931-1.19l-6.514-6.36A3.255 3.255 0 0 1 2 17.216a3.263 3.263 0 0 1 3.22-3.299 3.26 3.26 0 0 1 3.3 3.22c.005.49-.1.974-.311 1.416l6.457 6.303c.71.694 1.898.679 2.593-.032l8.82-9.034c2.082-2.136 2.077-5.546-.016-7.604A5.34 5.34 0 0 0 22.29 6.63h-.043a5.3 5.3 0 0 0-3.783 1.61l-1.841 1.89a1.18 1.18 0 0 1-1.67.024l-.004-.003-1.894-1.842c-2.104-2.058-5.503-2.016-7.582.095a1.18 1.18 0 0 1-1.67.013L3.8 8.413a1.186 1.186 0 0 1-.016-1.673c2.989-3.036 7.888-3.094 10.928-.127l1.042 1.015 1.016-1.041a7.65 7.65 0 0 1 5.456-2.326h.064c2.052 0 3.977.795 5.435 2.237 3.015 2.968 3.036 7.877.047 10.944"
    })
  }));
};
ServiceHubIcon.displayName = 'ServiceHubIcon';